import { makeStyles, tokens } from '@fluentui/react-components';

export const useContractNegotiationFormStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
  },
  formRow: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap',
    '& > *': {
      flex: 1,
      minWidth: '200px',
    },
  },
  formActions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    justifyContent: 'flex-end',
    paddingTop: tokens.spacingVerticalM,
  },
});
